import { Subject } from 'rxjs';

export class ChannelSubscription {
  public subject: Subject<Record<string, unknown>>;

  constructor(public channelName: string) {
    this.subject = new Subject<Record<string, unknown>>();
  }
}
